import { Sprint } from "./types";

export const startOfWeekMonday = (d: Date) => {
  const date = new Date(d);
  const day = date.getDay();
  const diff = (day === 0 ? -6 : 1) - day;
  date.setDate(date.getDate() + diff);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const startOfMonth = (d: Date) => {
  const date = new Date(d);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const addDays = (d: Date, n: number) => {
  const date = new Date(d);
  date.setDate(date.getDate() + n);
  return date;
};

export const addMonths = (d: Date, n: number) => {
  const date = new Date(d);
  date.setMonth(date.getMonth() + n);
  return date;
};

export const getDaysInMonth = (d: Date) => {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
};

export const fmtDayShort = (d: Date) =>
  d.toLocaleDateString(undefined, { weekday: "short" });

export const fmtDayNum = (d: Date) =>
  d.toLocaleDateString(undefined, { day: "2-digit" });

export const fmtMonthYear = (d: Date) =>
  d.toLocaleDateString(undefined, { month: "short", year: "numeric" });

export const ymd = (d: Date) => d.toISOString().slice(0, 10);

export const isDateInRange = (
  dateStr: string,
  startDate: Date,
  endDate: Date
): boolean => {
  const date = new Date(dateStr);
  return date >= startDate && date <= endDate;
};

export const checkDateStatus = (
  dueDate: string | null,
  sprint: Sprint | undefined,
  today: Date
) => {
  if (!dueDate) return { isOverdue: false, isOutOfSprint: false };

  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0);

  let isOverdue = false;
  let isOutOfSprint = false;

  if (sprint?.startDate && sprint?.endDate) {
    const sprintStart = new Date(sprint.startDate);
    const sprintEnd = new Date(sprint.endDate);
    sprintStart.setHours(0, 0, 0, 0);
    sprintEnd.setHours(0, 0, 0, 0);

    const isWithinSprint = due >= sprintStart && due <= sprintEnd;

    if (isWithinSprint && due < today) {
      isOverdue = true;
    }

    if (!isWithinSprint) {
      isOutOfSprint = true;
    }
  } else {
    isOverdue = due < today;
  }

  return { isOverdue, isOutOfSprint };
};
